import { render, staticRenderFns } from "./UpdatePhone.vue?vue&type=template&id=8b607370&"
import script from "./UpdatePhone.vue?vue&type=script&lang=ts&"
export * from "./UpdatePhone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports